import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-207dcc42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_2 = ["checked", "id"]
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "flex justify-center py-3" }
const _hoisted_5 = {
  key: 0,
  class: "mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["layout-card", { 'layout-card--selected': _ctx.isSelected }]),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('select', _ctx.id)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("input", {
        checked: _ctx.isSelected,
        id: _ctx.id,
        type: "radio",
        value: "",
        name: "layout-radio",
        class: "radio-primary",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('select', _ctx.id)))
      }, null, 40, _hoisted_2),
      _createElementVNode("label", {
        for: _ctx.id,
        class: "text-sm font-medium text-primary-dark cursor-pointer"
      }, _toDisplayString(_ctx.label), 9, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
    ]),
    (_ctx.$slots.extra)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "extra", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}